var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1037,
    height: 160,
    viewBox: "0 0 1037 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144.346 16.6909C127.346 2.93635 106.173 0 91.491 0H0V159.491H91.491C128.736 159.491 168.455 139.709 168.455 84.3819V73.8728C168.455 48.8364 160.418 29.5182 144.346 16.6909ZM128.118 84.3819C128.118 114.055 112.355 129.046 81.1364 129.046H40.1819V29.2091H81.1364C112.355 29.2091 128.118 44.2 128.118 73.8728V84.3819Z",
    fill: "#F5EAD2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M242.948 0H202.611V159.383H242.948V0Z",
    fill: "#F5EAD2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M444.165 159.491H394.247L344.793 103.391L317.438 134.455V159.491H277.102V0H317.438V77.891L385.902 0H435.82L369.829 75.1091L444.165 159.491Z",
    fill: "#F5EAD2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M581.556 0H517.419C493.001 0 465.337 0 465.337 34V125.491C465.337 159.491 493.001 159.491 517.419 159.491H581.556C605.974 159.491 633.792 159.491 633.792 125.491V34C633.792 0 605.974 0 581.556 0ZM593.456 123.173C593.456 128.891 590.519 129.046 583.565 129.046H515.41C508.61 129.046 505.519 128.891 505.519 123.173V36.3182C505.519 30.6 508.61 30.4455 515.41 30.4455H583.565C590.519 30.4455 593.456 30.6 593.456 36.3182V123.173Z",
    fill: "#F5EAD2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M836.4 91.491V125.491C836.4 159.491 808.736 159.491 784.163 159.491H667.945V129.046H786.327C793.127 129.046 796.218 128.891 796.218 123.173V93.8091C796.218 88.091 793.127 87.9364 786.327 87.9364H720.181C695.609 87.9364 667.945 87.9364 667.945 53.9364V34C667.945 0 695.609 0 720.181 0H826.045V30.4455H718.018C711.218 30.4455 708.281 30.6 708.281 36.3182V51.6182C708.281 57.3364 711.218 57.4909 718.018 57.4909H784.163C808.736 57.4909 836.4 57.4909 836.4 91.491Z",
    fill: "#F5EAD2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1037 0V30.4455H966.682V159.491H926.5V30.4455H856.182V0H1037Z",
    fill: "#F5EAD2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footerLogo.4ccd06afe5bdfd22c8639188d53c88f5.svg";
export { ForwardRef as ReactComponent };